import React, { Component } from 'react';
import { connect } from 'react-redux';
import { navigateAction } from 'fluxible-router';
import LoginPageLogo from 'app/scripts/components/common/login/logo';
import classnames from 'classnames';
import DisclaimerAndRights from '../../../common/disclaimer-rights';
import TextField from '../../../common/inputs/text-field';
import { getNetwork, getSpotId } from '../../../../services/app-state';
import resetPasswordAction from '../../state/actions/reset-password';
import { PasswordStrengthIndicator } from './strength-indicator';
import { State } from 'state';
import { NetworkRequestStatus } from '../../state';
import { getPasswordScore } from 'app/scripts/utils/password-validator';

interface IProps {
  status: string;
  ticket: string;
  resetPassword: (props: { password: string; ticket: string }) => any;
}

interface IState {
  password: { status: NetworkRequestStatus; message: string; value: string; strength: any };
  confirmPassword: { status: NetworkRequestStatus; message: string; value: string; strength: any };
  currentPasswordCheck: any;
}

const { NONE, LOADING, SUCCESS, ERROR } = NetworkRequestStatus;

const mapStateToProps = (state: State) => ({
  status: state?.account?.resetPassword?.status || NONE
});

const mapDispatchToProps = dispatch => ({
  resetPassword: props => {
    dispatch(resetPasswordAction(props));
  }
});

class ResetPassword extends Component<IProps, IState> {
  // private debouncedPassStrengthCheck: Function;

  constructor(props, context) {
    super(props, context);
    this.state = {
      password: { status: NONE, message: null, value: '', strength: null },
      confirmPassword: { status: NONE, message: null, value: '', strength: null },
      currentPasswordCheck: null
    };
    // this.debouncedPassStrengthCheck = debounce(this.checkPasswordStrength, 1000);
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    var { status } = this.props;
    if (status !== nextProps.status && nextProps.status === SUCCESS) {
      var queryParams = null;
      var network = getNetwork();
      queryParams = '?password_set=true';
      let url = `/network/${network.name}${queryParams}`;
      context.executeAction(navigateAction, { url });
    }
  }

  handlePasswordKeyStroke(value) {
    var password = Object.assign({}, this.state.password);
    password.status = NONE;
    password.message = null;
    password.value = value;

    if (password.value.length === 0) {
      password.status = ERROR;
      password.strength = 'weak';
    }

    this.setState({ password });
  }

  checkPasswordStrength(password) {
    if (password.value.length === 0) {
      password.status = ERROR;
      password.strength = 'weak';
      return password;
    }

    const score = getPasswordScore(password.value);
    const strength = score < 1 ? 'weak' : score < 3 ? 'medium' : 'strong';
    password.strength = strength;

    if (strength === 'weak') {
      password.status = ERROR;
      password.message = 'Password is too weak';
    } else {
      password.status = SUCCESS;
    }

    this.setState({ password });
    return password;
  }

  handlePasswordChange(value) {
    var password = Object.assign({}, this.state.password);
    password.status = NONE;
    password.message = null;
    password.value = value;

    // Update password strength
    password = this.checkPasswordStrength(password);

    // Update password match status
    let [updatedPassword, _] = this.matchPasswordsValidation(password, this.state.confirmPassword);

    this.setState({ password: updatedPassword });
  }

  matchPasswordsValidation(password, confirmPassword) {
    const isEmpty = password.value.trim().length === 0 || confirmPassword.value.trim().length === 0;

    if (isEmpty) {
      return [password, confirmPassword];
    }

    const isPasswordsMatch = confirmPassword.value === password.value;

    if (!isPasswordsMatch) {
      confirmPassword.status = ERROR;
      confirmPassword.message = "Passwords don't match";
    } else {
      confirmPassword.status = SUCCESS;
    }

    return [password, confirmPassword];
  }

  handleConfirmPasswordChange(value) {
    var confirmPassword = Object.assign({}, this.state.confirmPassword);

    confirmPassword.status = NONE;
    confirmPassword.message = null;
    confirmPassword.value = value;

    let [_, updatedConfirmPassword] = this.matchPasswordsValidation(
      this.state.password,
      confirmPassword
    );

    this.setState({ confirmPassword: updatedConfirmPassword });
  }

  save() {
    var { status, ticket } = this.props;
    var password = this.state.password.value;

    if (status !== LOADING) {
      this.props.resetPassword({
        password,
        ticket
      });
    }
  }

  canBeContinued() {
    return this.state.password.status === SUCCESS && this.state.confirmPassword.status === SUCCESS;
  }

  render() {
    var passwordField = this.state.password;
    var confirmPasswordField = this.state.confirmPassword;
    var { status } = this.props;
    var errorMessage = null;
    var className = 'form-wrapper';
    if (status === ERROR) {
      errorMessage = <div className="error-message">Please check your entry and try again.</div>;
      className += ' has-message';
    }

    var network = getNetwork();
    var buttonStyle = {
      backgroundColor: network.color
    };

    const passwordClassName = classnames('password-input', 'inside', passwordField.strength);

    return (
      <div className="form">
        <div className={className}>
          {errorMessage}
          <div className="main-content">
            <LoginPageLogo />
            <div className="text-section">
              <span className="title">Set Your New Password</span>
            </div>
            <div className="fields">
              <div className="input-title">New password</div>
              <TextField
                type="password"
                fieldClassName="margin-bottom-5"
                className={passwordClassName}
                validation={passwordField}
                showValidationTooltip
                onChange={this.handlePasswordChange.bind(this)}
              />
              <PasswordStrengthIndicator strength={passwordField.strength} />
              <div className="input-title margin-top-20">Confirm new password</div>
              <TextField
                type="password"
                validation={confirmPasswordField}
                showValidationTooltip
                onChange={this.handleConfirmPasswordChange.bind(this)}
              />
            </div>
            <button
              className="continue-button"
              style={buttonStyle}
              onClick={this.save.bind(this)}
              disabled={!this.canBeContinued()}
            >
              Save
            </button>
          </div>
          <DisclaimerAndRights />
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ResetPassword);
